import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import ErrorComponent from "../ErrorComponent";
import { tCommon } from "../../utils/table";

const [HbrIllustration] = reactWrapper(["hbr-illustration"]);

const NoData = ({ count = 0, loader = false, error = null, text }) => {
  const displayText = text ?? tCommon("noData");

  return (
    <>
      {count === 0 && loader === false && (
        <div slot="empty" className="hbr-css__table-empty-state">
          {error === null ? (
            <HbrIllustration size="medium">
              <div slot="body">{displayText}</div>
            </HbrIllustration>
          ) : (
            <ErrorComponent
              {...error}
              className="small-dashlet-error"
              width="110px"
            />
          )}
        </div>
      )}
    </>
  );
};

NoData.propTypes = {
  count: PropTypes.number,
  loader: PropTypes.bool,
  error: PropTypes.object,
  text: PropTypes.string,
};

export default NoData;
